import axios from 'axios';

import { defineNuxtPlugin } from '#app';
import httpAlertsConnector from '@/connectors/http-alerts';
import httpCacheConnector from '@/connectors/http-cash';
import httpAuthConnector from '@/connectors/http-auth';
import { CoreServices } from '~/service/core';
import { useUserStore } from '~/stores/user/useUserStore';
import Flicking from '@egjs/vue3-flicking';

const createAxiosInstance = (baseURL: string) => {
    const instance = axios.create({
        baseURL,
        timeout: 10000,
        headers: {
            'Content-Type': 'application/json'
        }
    });

    httpAlertsConnector(instance);
    httpCacheConnector(instance);
    httpAuthConnector(instance);

    return instance;
};

export default defineNuxtPlugin({
    name: 'init',
    parallel: false,
    async setup(nuxtApp) {
        const userStore = useUserStore();
        nuxtApp.vueApp.component('Flicking', Flicking);

        if (import.meta.browser) {
            userStore.setReady();
            nuxtApp.hook(
                'app:suspense:resolve',
                function () {
                    userStore.setIsHydrated();
                }
            );
        }
        else {
            userStore.setReady();
        }

        const primaryAxios = createAxiosInstance(import.meta.env.VITE_GBZR_API_URL);
        const secondaryAxios = createAxiosInstance(import.meta.env.VITE_WTF_API_URL);

        const evmCore = new CoreServices({
            axios: primaryAxios
        });

        const wtfApi = createWTFApi(secondaryAxios);

        return {
            provide: {
                evmCore,
                evmApi: evmCore.api,
                wtfApi
            }
        };
    }
});
